import React, { useState, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateCellEditor =({ value, onValueChange, stopEditing }) => {
  const initialDate = value ? new Date(value) : null;
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const refContainer = useRef(null);


  function handleChange(date) {
    setSelectedDate(date);
    onValueChange(date); // tells AG Grid the new value
    //stopEditing();       // closes the editor
  }

  return (
    <div ref={refContainer}>
      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        className="ag-input-field-input ag-text-field-input"
      />
    </div>
  );
};

export default DateCellEditor;
